// Models
// Constants
import { projectManagerAgentId } from "@ms/uno-constants/lib/local/AgentConstants";
import copilotLogo from "@ms/uno-resources/lib/local/images/copilot-logo.png";
// Strings
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Project Manager Agent getter
 */ export function getProjectManagerAgent() {
    return {
        displayName: Strings.Project_Manager,
        id: projectManagerAgentId,
        logoUrl: copilotLogo
    };
}
